import { render, staticRenderFns } from "./ActiveAssignment.vue?vue&type=template&id=77700516"
import script from "./ActiveAssignment.vue?vue&type=script&lang=ts"
export * from "./ActiveAssignment.vue?vue&type=script&lang=ts"
import style0 from "./ActiveAssignment.vue?vue&type=style&index=0&id=77700516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports